<div class="sidenav-user">
    <div class="d-flex justify-content-between align-items-center">
        <div>
            <a routerLink="/pages/profile" class="link-reset">
                <img src="assets/images/users/user-3.jpg" alt="user-image"
                     class="rounded-circle mb-2 avatar-md">
                <span class="sidenav-user-name fw-bold">Geneva K.</span>
                <span class="fs-12 fw-semibold" data-lang="user-role">Art Director</span>
            </a>
        </div>
        <div ngbDropdown [placement]="'bottom-end'">
            <button ngbDropdownToggle
                    class="btn btn-link p-0 dropdown-toggle drop-arrow-none link-reset sidenav-user-set-icon"
                    data-bs-toggle="dropdown" data-bs-offset="0,12">
                <ng-icon name="tablerSettings" size="24" class="align-middle ms-1"/>
            </button>

            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end mt-1">

                @for (item of menuItems; track $index) {
                    <div>
                        @if (item.isHeader) {
                            <div class="dropdown-header noti-title">
                                <h6 class="text-overflow m-0">{{ item.label }}</h6>
                            </div>
                        }

                        @if (item.isDivider) {
                            <div class="dropdown-divider"></div>
                        }

                        @if (!item.isHeader && !item.isDivider) {
                            <a  [routerLink]="item.url" class="dropdown-item"
                               [class]="item.class">
                                <ng-icon [name]="item.icon" size="17"
                                         class="align-middle d-inline-flex align-items-center me-2"/>
                                <span class="align-middle" [innerHTML]="item.label"></span>
                            </a>
                        }
                    </div>
                }

            </div>
        </div>
    </div>
</div>
